import React, { useEffect, useState } from "react";
import {
  Box,
  Typography,
  Button,
  Accordion,
  AccordionActions,
  AccordionSummary,
  AccordionDetails,
  Checkbox,
  Table,
  TableContainer,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  useTheme,
  useMediaQuery,
} from "@mui/material";

import ListAltOutlined from "@mui/icons-material/ListAltOutlined";
import RemoveOutlinedIcon from "@mui/icons-material/RemoveOutlined";
import AddOutlinedIcon from "@mui/icons-material/AddOutlined";

export default function AiResultContent({ aiRetValus, onApply, onClose }) {
  // aiRetValus = {
  //   Title: "My sample title for a toy Toys Only a sample to tests the wrap",
  //   Description: "Building & Construction Toys Only a sample to tests the wrap",
  //   Category: "Building & Construction Toys",
  //   Subcategory: "Magnetic Builders",
  //   Brand: "BrightyBright",
  //   Warnings: "Choking hazard - small parts",
  //   "Age Group": "3-5",
  //   Material: "Plastic",
  //   Dimensions: "Not specified",
  //   Weight: "Varies",
  //   Color: "Multi Color",
  //   "Sub-Color": "Not specified",
  //   "No of Players": "Not specified",
  //   "Battery Required": "No",
  //   "Battery Included": "No",
  //   "Assembly Required": "No",
  //   "Level of Difficulty": "Easy",
  //   "Game Duration": "Unlimited",
  //   "Manufacturer Country": "Not specified",
  // };

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const [expanded, setExpanded] = useState({
    required: true,
    optional: true,
  });

  const handleToggle = key => (event, isExpanded) => {
    setExpanded(prev => ({ ...prev, [key]: isExpanded }));
  };

  const [requiredChecked, setRequiredChecked] = useState({
    selectAll: false,
    title: false,
    description: false,
    category: false,
    subcategory: false,
    brand: false,
    warnings: false,
  });

  const requiredRows = [
    { key: "selectAll", attribute: "Select All/Clear All", value: "" },
    { key: "title", attribute: "Title", value: aiRetValus.Title },
    { key: "description", attribute: "Description", value: aiRetValus.Description },
    { key: "category", attribute: "Category", value: aiRetValus.Category },
    { key: "subcategory", attribute: "Subcategory", value: aiRetValus.Subcategory },
    { key: "brand", attribute: "Brand", value: aiRetValus.Brand },
    { key: "warnings", attribute: "Warnings", value: aiRetValus.Warnings },
  ];

  const handleRequiredCheck = key => event => {
    const newChecked = {
      ...requiredChecked,
      [key]: event.target.checked,
    };

    if (key === "selectAll") {
      Object.keys(newChecked).forEach(k => {
        newChecked[k] = event.target.checked;
      });
    }

    const allSelected = Object.keys(newChecked)
      .filter(k => k !== "selectAll")
      .every(k => newChecked[k]);
    newChecked.selectAll = allSelected;

    setRequiredChecked(newChecked);
  };

  const [optionalChecked, setOptionalChecked] = useState({
    selectAll: false,
    material: false,
    color: false,
    subcolor: false,
    age: false,
    difficulty: false,
    country: false,
    BatteryReq: false,
    BatteryIncd: false,
    assemblyReq: false,
    duration: false,
    dimensions: false,
    weight: false,
    players: false,
  });

  const optionalRows = [
    { key: "selectAll", attribute: "Select All/Clear All", value: "" },
    { key: "age", attribute: "Age Group", value: aiRetValus["Age Group"] },
    { key: "material", attribute: "Material", value: aiRetValus.Material },
    { key: "dimensions", attribute: "Dimensions", value: aiRetValus.Dimensions },
    { key: "weight", attribute: "Weight", value: aiRetValus.Weight },
    { key: "color", attribute: "Color", value: aiRetValus.Color },
    { key: "subcolor", attribute: "Sub-Color", value: aiRetValus["Sub-Color"] },
    { key: "players", attribute: "No of Players", value: aiRetValus["No of Players"] },
    {
      key: "BatteryReq",
      attribute: "Battery Required",
      value: aiRetValus["Battery Required"],
    },
    {
      key: "BatteryIncd",
      attribute: "Battery Included",
      value: aiRetValus["Battery Included"],
    },
    {
      key: "assemblyReq",
      attribute: "Assembly Required",
      value: aiRetValus["Assembly Required"],
    },
    {
      key: "difficulty",
      attribute: "Level of Difficulty",
      value: aiRetValus["Level of Difficulty"],
    },
    { key: "duration", attribute: "Game Duration", value: aiRetValus["Game Duration"] },
    {
      key: "country",
      attribute: "Manufacturer Country",
      value: aiRetValus["Manufacturer Country"],
    },
  ];

  const handleOptionalCheck = key => event => {
    const newChecked = {
      ...optionalChecked,
      [key]: event.target.checked,
    };

    if (key === "selectAll") {
      Object.keys(newChecked).forEach(k => {
        newChecked[k] = event.target.checked;
      });
    }

    const allSelected = Object.keys(newChecked)
      .filter(k => k !== "selectAll")
      .every(k => newChecked[k]);
    newChecked.selectAll = allSelected;

    setOptionalChecked(newChecked);
  };

  const handleApplyVals = () => {
    onApply(requiredChecked, optionalChecked);
    // console.log("requiredChecked: ", requiredChecked);
  };

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        // width: "100%",
        // overflowY: "auto",
        // gap: "10px",
        // maxHeight: "70vh",
      }}
    >
      <Accordion
        sx={{
          width: isMobile ? 320 : 550,
          borderRadius: "8px",
          border: "1px solid #E1E1E1",
          boxShadow: "none",
        }}
        expanded={expanded.required}
        onChange={handleToggle("required")}
      >
        <AccordionSummary
          expandIcon={expanded.required ? <RemoveOutlinedIcon /> : <AddOutlinedIcon />}
        >
          <Box sx={{ display: "flex", alignItems: "center" }}>
            <ListAltOutlined
              sx={{ height: "24px", width: "24px", color: "#EF5658", mr: 1 }}
            />
            <Typography variant="h6" sx={{ fontWeight: 600, fontSize: 16 }}>
              Required Information
            </Typography>
          </Box>
        </AccordionSummary>

        <AccordionDetails sx={{ p: 0 }}>
          <Table
            size="small"
            sx={{
              width: "100%",
              borderCollapse: "collapse",
              // border: "none",
              "& .MuiTableCell-root": { borderBottom: "none" },
              "& .MuiTableRow-root:nth-of-type(odd)": {
                backgroundColor: "#fff",
              },
              "& .MuiTableRow-root:nth-of-type(even)": {
                backgroundColor: "#FAFAFA",
              },
            }}
          >
            <TableHead>
              <TableRow>
                <TableCell
                  sx={{
                    pl: "16px",
                    backgroundColor: "#EEEEEE",
                    width: "50%",
                    fontWeight: 500,
                    fontSize: 12,
                  }}
                >
                  Attribute
                </TableCell>
                <TableCell
                  sx={{
                    backgroundColor: "#EEEEEE",
                    width: "50%",
                    fontWeight: 500,
                    fontSize: 12,
                  }}
                >
                  Value
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {requiredRows.map(row => (
                <TableRow key={row.key}>
                  <TableCell
                    sx={{
                      display: "flex",
                      // flexDirection: "column",
                      alignItems: "center",
                      // pt: 1,
                      pl: "5px",
                      // gap: 1,
                    }}
                  >
                    <Checkbox
                      checked={requiredChecked[row.key]}
                      onChange={handleRequiredCheck(row.key)}
                      sx={{ p: "4px" }}
                    />
                    <Typography variant="caption" sx={{ fontWeight: 400, fontSize: 12 }}>
                      {row.attribute}
                    </Typography>
                  </TableCell>
                  <TableCell>
                    <Typography variant="caption" sx={{ fontWeight: 400, fontSize: 12 }}>
                      {row.value}
                    </Typography>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </AccordionDetails>
      </Accordion>

      <Accordion
        sx={{
          width: isMobile ? 320 : 550,
          borderRadius: "8px",
          border: "1px solid #E1E1E1",
          boxShadow: "none",
        }}
        expanded={expanded.optional}
        onChange={handleToggle("optional")}
      >
        <AccordionSummary
          expandIcon={expanded.optional ? <RemoveOutlinedIcon /> : <AddOutlinedIcon />}
        >
          <Box sx={{ display: "flex", alignItems: "center" }}>
            <ListAltOutlined
              sx={{ height: "24px", width: "24px", color: "#EF5658", mr: 1 }}
            />
            <Typography variant="h6" sx={{ fontWeight: 600, fontSize: 16 }}>
              Optional Information
            </Typography>
          </Box>
        </AccordionSummary>
        <AccordionDetails sx={{ p: 0 }}>
          <Table
            size="small"
            sx={{
              width: "100%",
              borderCollapse: "collapse",
              // border: "none",
              "& .MuiTableCell-root": { borderBottom: "none" },
              "& .MuiTableRow-root:nth-of-type(odd)": {
                backgroundColor: "#fff",
              },
              "& .MuiTableRow-root:nth-of-type(even)": {
                backgroundColor: "#FAFAFA",
              },
            }}
          >
            <TableHead>
              <TableRow>
                <TableCell
                  sx={{
                    pl: "16px",
                    backgroundColor: "#EEEEEE",
                    width: "50%",
                    fontWeight: 500,
                    fontSize: 12,
                  }}
                >
                  Attribute
                </TableCell>
                <TableCell
                  sx={{
                    backgroundColor: "#EEEEEE",
                    width: "50%",
                    fontWeight: 500,
                    fontSize: 12,
                  }}
                >
                  Value
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {optionalRows.map(row => (
                <TableRow key={row.key}>
                  <TableCell
                    sx={{
                      display: "flex",
                      // flexDirection: "column",
                      alignItems: "center",
                      // pt: 1,
                      pl: "5px",
                      // gap: 1,
                    }}
                  >
                    <Checkbox
                      checked={optionalChecked[row.key]}
                      onChange={handleOptionalCheck(row.key)}
                      sx={{ p: "4px" }}
                    />
                    <Typography variant="caption" sx={{ fontWeight: 400, fontSize: 12 }}>
                      {row.attribute}
                    </Typography>
                  </TableCell>
                  <TableCell>
                    <Typography variant="caption" sx={{ fontWeight: 400, fontSize: 12 }}>
                      {row.value}
                    </Typography>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </AccordionDetails>
      </Accordion>

      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          gap: 2,
          mt: 2,
        }}
      >
        <Button
          onClick={handleApplyVals}
          variant="contained"
          sx={{
            backgroundColor: "#EF5658",
            color: "white",
            borderRadius: "4px",
            py: 1.5,
            height: "36px",
            fontSize: "14px",
            fontWeight: "medium",
            textTransform: "uppercase",
            minWidth: "140px",
            "&:hover": {
              backgroundColor: "#D33338",
            },
          }}
        >
          Apply Values
        </Button>
        <Button
          onClick={onClose}
          variant="outlined"
          sx={{
            borderColor: "#666",
            color: "#666",
            borderRadius: "4px",
            px: 3,
            py: 1.5,
            fontSize: "14px",
            fontWeight: "medium",
            height: "36px",
            textTransform: "uppercase",
            maxWidth: "140px",
            "&:hover": {
              borderColor: "#666",
              backgroundColor: "rgba(0,0,0,0.04)",
            },
          }}
        >
          Close
        </Button>
      </Box>
    </Box>
  );
}
